import {
    addMapModuleInit,
    loadBDMapScript,
    runMapModuleInit,
    bdMapIsLoad,
} from '@/modules/onlineMap/util';

export default {
    addMapModuleInit,
    loadBDMapScript,
    runMapModuleInit,
    bdMapIsLoad,
};
